import { DARK } from '@core/constants/theme';
import { styled } from '@ublend-npm/aulaui-core';

export const QuoteViewContainer = styled('div')`
  display: flex;
  flex-direction: row;
  margin-left: 52px;
  cursor: pointer;
  padding-top: 0.62rem;
`;

export const QuoteDelimiter = styled('div')`
  display: none;
`;

export const QuoteMessageContainer = styled('div')`
  display: flex;
  flex-direction: column;
  border-left: 2px solid #666666;
  padding-left: 0.62rem;
  width: 100%;
  margin-bottom: 8px;
`;

export const QuoteContainer = styled('div')(({ theme }) => ({
  fontStyle: 'normal',
  fontWeight: 'normal',
  fontSize: '13px',
  lineHeight: '1.4',
  color: theme.palette.mode === DARK ? '#FFFFFFB2' : '#000',
  whiteSpace: 'nowrap',
  overflow: 'hidden',
  textOverflow: 'ellipsis',
  fontFamily: 'Roboto, sans-serif',
  paddingRight: '20px',
}));

export const Author = styled('div')(({ theme }) => ({
  color: theme.palette.primary.main,
  fontSize: '12px',
  fontWeight: 600,
  fontFamily: 'Roboto, sans-serif',
}));
